import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import "./UpdateNotification.scss";

const UpdateNotification = () => {
    const [seconds, setSeconds] = useState(5);

    useEffect(() => {
        const timer = setInterval(() => {
            setSeconds((prev) => {
                if (prev <= 1) {
                    clearInterval(timer);
                    window.location.reload(true);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    const handleRefreshNow = () => {
        window.location.reload(true);
    };

    const circumference = 2 * Math.PI * 35;
    const progress = ((5 - seconds) / 5) * circumference;

    return createPortal(
        <div className="update-overlay">
            <div className="update-card">
                <div className="update-header">
                    <div className="update-icon">
                        <svg className="countdown-ring" width="80" height="80">
                            <circle
                                className="countdown-ring-circle-bg"
                                cx="40"
                                cy="40"
                                r="32"
                                fill="none"
                                stroke="#414141"
                                strokeWidth="5"
                            />
                            <circle
                                className="countdown-ring-circle"
                                cx="40"
                                cy="40"
                                r="32"
                                fill="none"
                                stroke="#35d269"
                                strokeWidth="5"
                                strokeDasharray={circumference}
                                strokeDashoffset={circumference - progress}
                                strokeLinecap="round"
                                transform="rotate(-90 40 40)"
                            />
                            <text
                                x="40"
                                y="40"
                                textAnchor="middle"
                                dy="7"
                                fontSize="26"
                                fontWeight="bold"
                                fill="#35d269"
                            >
                                {seconds}
                            </text>
                        </svg>
                    </div>

                    <div className="update-text">
                        <h2 className="update-title">New Update Available</h2>
                        <p className="update-subtitle">
                            Refreshing in {seconds} {seconds === 1 ? "second" : "seconds"}...
                        </p>
                    </div>
                </div>

                <div className="update-description">
                    <p>
                        A new version of the app has been released with the latest features and improvements.
                    </p>
                </div>

                <button className="update-button" onClick={handleRefreshNow}>
                    <svg
                        className="refresh-icon"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <path d="M21.5 2v6h-6M2.5 22v-6h6M2 11.5a10 10 0 0 1 18.8-4.3M22 12.5a10 10 0 0 1-18.8 4.2" />
                    </svg>
                    Refresh Now
                </button>
            </div>
        </div>,
        document.body
    );
};

export default UpdateNotification;
